import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button, Form, Input } from "../../../styles";
import { useUserContext } from "../../../context/user_context";
import { useItemContext } from "../../../context/item_context";
import Api from "../../../api/axios";


const AddItemCategory = (props) => {
  const [issending, setissending] = useState(false);

  const [formField, setformField] = useState({});

  const { btoken, stoken, usertoken } = useUserContext();
  const {
    openAddItem,
    showAddItemCategory, CloseAddItemCategory,
    getItemCategoryData
  } = useItemContext();

  function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }

  function submitFn(e) {
    e.preventDefault();
    if (formField.category) {
      setissending(true);
      const data = {
        category: formField.category,
        btoken, stoken, usertoken
      };

      Api.post(`/addItemCategory`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            toast.success(res.message);
            clear();
            getItemCategoryData();
            CloseAddItemCategory();
            openAddItem();
          }
        })
        .catch((error) => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.error("Category is required !!!");
    }
  }

  // clear Form Field
  function clear() {
    setformField({ category: "" });
  }


  return (
    <>
      <Modal
        show={showAddItemCategory}
        onHide={CloseAddItemCategory}
        backdrop="static"
        keyboard={true}
        centered
        size="lg"
      >
        <Modal.Body>
          <Modal.Header closeButton>
            <h6 className="fw-bold pry-text ml-auto">
              Add New Item Category
            </h6>
          </Modal.Header>

          <section className=" ">
            <div className="container">
              <div className="text-center">
                <div className="form">
                  <Form onSubmit={(e) => submitFn(e)}>
                    <div className="row justify-content-center text-start">
                      <div className="col-md-12">
                        <label className="mb-0"> Category Name:</label>
                        <Input
                          type="text"
                          name="category"
                          placeholder="Enter category"
                          onChange={handleChange}
                          required
                          value={formField.category}
                        />
                      </div>

                      <div className="col-md-10 mx-auto text-center">

                        <div className="mb-4 text-center">
                          <Button
                            pry
                            type="submit"
                            disabled={issending}
                            className="btn m-0 w-100"  >
                            {issending ? 'loading...' : "Submit"}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </section>
        </Modal.Body>
      </Modal>


    </>
  );
};

export default AddItemCategory;
